module.exports = __webpack_public_path__ + "static/media/avatar.963722b1.png";